import { AxiosInstance } from 'axios';
import {
  InspectionServicesEndpoint,
  SearchDamageCodesRequest,
  SearchDamageCodesResponse,
  SearchInspectionsRequest,
  SearchInspectionsResponse,
  CreateInspectionRequest,
  CreateInspectionResponse,
  AddDamageCodeRequest,
  AddDamageCodeResponse,
  RemoveDamageCodeRequest,
  RemoveDamageCodeResponse,
} from './InspectionServices.types';

export class InspectionServices implements InspectionServicesEndpoint {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  searchInspections(request: SearchInspectionsRequest) {
    return this.instance.get<SearchInspectionsResponse>('/inspections', {
      params: request.queryParams,
    });
  }

  createInspection(request: CreateInspectionRequest) {
    return this.instance.post<CreateInspectionResponse>('/inspections', request.body);
  }

  searchDamageCodes(request: SearchDamageCodesRequest) {
    return this.instance.get<SearchDamageCodesResponse>('/inspections/codes', {
      params: request.queryParams,
    });
  }

  addDamageCode(request: AddDamageCodeRequest) {
    return this.instance.post<AddDamageCodeResponse>(
      `/inspections/${request.routeParams.id}/damages`,
      request.body,
    );
  }

  removeDamageCode(request: RemoveDamageCodeRequest) {
    return this.instance.delete<RemoveDamageCodeResponse>(
      `/inspections/${request.routeParams.inspectionId}/damages/${request.routeParams.damageId}`,
    );
  }
}
